import {Module} from 'vuex-class-modules';
import store from '@/store';
import {displayControlApi as api} from '@/api';
import {
  DisplayControlAttributes as Attributes,
  DisplayControlCreate as Create,
  DisplayControlResource as Resource,
} from '@/interfaces';
import {ResourceType} from '@/enums';
import {CrudModuleAbstract} from './CrudModuleAbstract';
import {parseISO} from 'date-fns';

const defaultItem = (): Resource => {
  return {
    id: 'new',
    type: ResourceType.DisplayControl,
    attributes: {
      id: 0,
      controlKey: '',
      controlName: '',
      clearOnComplete: false,
      targeted: false,
      created: new Date(),
      modified: new Date(),
    },
  };
};

@Module
class DisplayControlModule extends CrudModuleAbstract<
  Resource,
  Attributes,
  Create
> {
  public cast(item: Resource): Resource {
    item.attributes.created = parseISO(String(item.attributes.created));
    item.attributes.modified = parseISO(String(item.attributes.modified));
    return item;
  }
}

export const displayControlModule = new DisplayControlModule(
  {
    store,
    name: ResourceType.DisplayControl,
  },
  () => api,
  defaultItem
);
